import { AutopilotTaskDto } from '@urbanx/agx.activities.client';

type TaskModalPageTask = AutopilotTaskDto & { id: string };

export interface TaskModalPage {
  task: TaskModalPageTask;
  completionTasks: AutopilotTaskDto[];
  stepBindings: TaskModalStepBinding[];
}

export interface TaskModalStepBinding {
  pageStepOrder: number;
  taskId: string;
  taskStepOrder: number;
}

export const createTaskModalPages = (tasks: AutopilotTaskDto[]): TaskModalPage[] =>
  tasks.map((task) => {
    if (!task.id) throw new Error('Task modal page task is missing an ID');

    return {
      task: task as TaskModalPageTask,
      completionTasks: [task],
      stepBindings:
        task.taskSteps?.map((step) => ({
          pageStepOrder: step.order ?? 0,
          taskId: task.id!,
          taskStepOrder: step.order ?? 0,
        })) ?? [],
    };
  });

export const resolveTaskModalPageCompletion = (
  pages: TaskModalPage[],
  incompletePageTaskIds: string[] = []
): boolean[] =>
  pages.map(
    (page) =>
      !incompletePageTaskIds.includes(page.task.id) &&
      page.completionTasks.every(
        (task) =>
          (task.taskSteps?.length ?? 0) > 0 && task.taskSteps?.every((step) => step.isCompleted)
      )
  );
